import React from 'react';
import { Grid, Tooltip, Typography } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

function ModoVisualizacaoObservacao(props) {
  const {
    filiado,
    observacaoSelecionada,
    setObservacaoSelecionada,
    visualizarListagem
  } = props;

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        md={2}
        xs={2}
      >
        <Tooltip
          title={'Clique para visualizar as observações do filiado'}
          children={
            <IconButton
              edge="end"
              onClick={e => visualizarListagem(e)}
            >
              <ArrowBackIcon fontSize={'default'}/>
            </IconButton>
          }
        >
        </Tooltip>
      </Grid>
      <Grid
        item
        md={10}
        xs={10}
      >
        <Typography
          variant="h4"
          color="textPrimary"
          gutterBottom
        >
          {observacaoSelecionada &&  observacaoSelecionada.titulo}
        </Typography>
      </Grid>
      <Grid
        item
        md={12}
        xs={12}
      >
        <Typography
          variant="body2"
          color="textSecondary"
          gutterBottom
        >
          {observacaoSelecionada &&  observacaoSelecionada.descricao}
        </Typography>
      </Grid>
    </Grid>
  );
}

ModoVisualizacaoObservacao.propTypes = {

};

export default ModoVisualizacaoObservacao;


